import * as z from "../../../framework";
import { userHasRight } from "../../../framework";
import { ComponentOptions, RightLockable } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import K_InsertObject from "../templates/K_InsertObject";

export interface InsertObjectOptions extends ComponentOptions {
    labelBind?: string;
    labelClasses?: string;
    iconType?: string;
    bsc?: string;
    requiredRight?: string;
}

export class InsertObject extends TemplateComponent {

    options: InsertObjectOptions & RightLockable;

    constructor(options: InsertObjectOptions) {
        super(K_InsertObject, options);
    }

    preRender() {
        const options = this.options;

        options.labelBind = z.util.buildDataBindSyntax(options.labelBind, "label");

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.containerClasses += " disabled right-locked";
            }
        }
    }

    setLabelBind(labelName) {
        var me = this;

        $("#" + me.id + " .insert-object-label").attr("data-bind", "text: " + labelName);
    }

}
